// https://github.com/your-org/videojs-play-from-beginning-button
const { videojs } = window
const Button = videojs.getComponent('Button')
export const PLUGIN_NAME = 'PlayFromBeginningButton'
const COMPONENT_NAME = 'PlayFromBeginningButton'

const registerPlugin = videojs.registerPlugin || videojs.plugin

function playFromBeginningPlugin () {
  this.ready(function onPlayerReady () {
    const player = this
    player.addClass('vjs-play-from-beginning')
    // Only add if not already present
    if (!player.controlBar.getChild(COMPONENT_NAME)) {
      player.controlBar.addChild(COMPONENT_NAME, {}, 1)
    }
  })
}

class PlayFromBeginningButton extends Button {
  constructor (player, options) {
    super(player, options)
    this.controlText('Play from beginning')
    this.addClass('vjs-play-from-beginning-button')
  }

  handleClick () {
    this.player().currentTime(0)
    this.player().play()
  }

  buildCSSClass () {
    return `vjs-control vjs-button vjs-play-from-beginning-button ${super.buildCSSClass()}`
  }
}

export function register (videojsIn = window.videojs) {
  videojsIn.registerComponent(COMPONENT_NAME, PlayFromBeginningButton)
  registerPlugin(PLUGIN_NAME, playFromBeginningPlugin)
}
